<template>
  <v-item-group
    v-model="source"
    class="d-flex ga-3"
    :class="{ 'opacity-60': disabled }"
    :disabled="disabled"
    mandatory>
    <v-item
      v-for="item in sources"
      :key="item.value"
      v-slot="{ isSelected, toggle }"
      :value="item.value">
      <v-card
        class="flex-1-1-0 border-md"
        :class="{ 'border-primary border-opacity-100': isSelected }"
        :color="isSelected ? 'primary' : undefined"
        :variant="isSelected ? 'tonal' : 'flat'"
        :link="!disabled"
        rounded="lg"
        @click="toggle">
        <v-card-text class="d-flex align-start ga-3 pa-3">
          <v-icon
            :icon="isSelected ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank'"
            :color="isSelected ? 'primary' : 'grey-lighten-1'"
            size="20"></v-icon>
          <div>
            <div class="text-body-2 font-weight-bold">{{ item.title }}</div>
            <div class="text-caption text-medium-emphasis">
              {{ item.description }}
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-item>
  </v-item-group>
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue'
import type { PackageParseType } from '@/utils/types'

defineOptions({
  name: 'PackageSourceSelect',
})

const source = defineModel({
  type: String as PropType<PackageParseType>,
  required: true,
})

const props = defineProps({
  version: { type: Number, required: true },
  disabled: { type: Boolean, default: false },
})

const sources = computed<
  Array<{ value: PackageParseType; title: string; description: string }>
>(() => [
  {
    value: 'excel',
    title: 'Excel',
    description: `Шаблон версії ${props.version}, файл з ID буде завантажено`,
  },
  {
    value: 'json',
    title: 'JSON',
    description: 'Версія пакета не змінюється',
  },
])
</script>
